import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=5dc2f136&scoped=true&"
import script from "./Role.vue?vue&type=script&lang=js&"
export * from "./Role.vue?vue&type=script&lang=js&"
import style0 from "./Role.vue?vue&type=style&index=0&id=5dc2f136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2f136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc2f136')) {
      api.createRecord('5dc2f136', component.options)
    } else {
      api.reload('5dc2f136', component.options)
    }
    module.hot.accept("./Role.vue?vue&type=template&id=5dc2f136&scoped=true&", function () {
      api.rerender('5dc2f136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Role.vue"
export default component.exports